import { FC } from 'react'
import { SearchScope } from '../../../types/searchScope'

/**
 * Oasis Explorer linked to https://abi-playground.oasis.io/.
 * Disabled for OXN — that playground is Oasis-hosted and not an OXN tool.
 */
export const AbiPlaygroundLink: FC<{
  address_eth: string
  scope: SearchScope
}> = () => null
